var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.users),function(user,idx){return _c('span',{key:user.id},[_c('router-link',{attrs:{"to":_vm.$objectViewRoute(user)}},[[_vm._v(" "+_vm._s(`${user.firstname} ${user.lastname} - ${user.email}`)+" "+_vm._s(_vm.users.length - 1 > idx ? "," : " ")),_c('br')]],2)],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }